import React, { useEffect, useState } from "react";
import DataTable from "../../../components/DataTable/DataTable";
import {
	AwaitingHeaderAF,
	AwaitingHeaderLease,
	DeployedHeaderAF,
	DeployedHeaderLease,
	InspectedHeaderAF,
	InspectedHeaderLease,
	MaintainedHeaderAF,
	MaintainedHeaderLease,
	PurchasedHeaderAF,
	PurchasedHeaderLease,
	RepairedHeaderAF,
	RepairedHeaderLease,
	RetainedHeaderAF,
	RetainedHeaderLease,
} from "../data";
import DeleteIcon from "../../../assets/icons/deleteIcon.svg";
// import ExportIcon from "../../../assets/icons/exportIcon.svg";
import { TableButton, TableToolbar } from "../../../components/DataTable/DataTable.styles";
import { Select, MenuItem } from "@mui/material";
import ConfirmModal from "../../../components/ConfirmModal";
import { getFilteredTableData } from "../../../utils/Utils";
import { useSelector } from "react-redux";
import { getCurrentUserInfo } from "../../../utils/UserAuth";

/* eslint-disable react/prop-types */
const LogisticsTable = ({ handleFilterChange, handleDeleteLOG }) => {
	const { currentTab, currentFilter, tableData } = useSelector((state) => state.logistics);
	const [TableHeadCells, setTableHeadCells] = useState(PurchasedHeaderLease);
	const [selectedItems, setSelectedItems] = useState([]);
	const [confirmModal, setConfirmModal] = useState(false);
	const [dateFilter, setDateFilter] = useState("6 Months");
	const [filteredData, setFilteredData] = useState([]);

	useEffect(() => {
		handleDateFilterChange({ target: { value: dateFilter } });
	}, [tableData]);

	useEffect(() => {
		setCurrentTableHeader();
	}, [currentTab, currentFilter]);

	const setCurrentTableHeader = () => {
		let TableHeader = [];
		const isLeasing = currentFilter == "lease";
		const newSections = ["retrieved_assets", "reassigned_assets", "sold_assets"];

		if (currentTab === "procured_assets") {
			TableHeader = isLeasing ? PurchasedHeaderLease : PurchasedHeaderAF;
		} else if (currentTab === "deployed_assets") {
			TableHeader = isLeasing ? DeployedHeaderLease : DeployedHeaderAF;
		} else if (currentTab === "maintained_assets") {
			TableHeader = isLeasing ? MaintainedHeaderLease : MaintainedHeaderAF;
		} else if (currentTab === "inspected_assets") {
			TableHeader = isLeasing ? InspectedHeaderLease : InspectedHeaderAF;
		} else if (currentTab === "retained_assets") {
			TableHeader = isLeasing ? RetainedHeaderLease : RetainedHeaderAF;
		} else if (currentTab === "repaired_assets") {
			TableHeader = isLeasing ? RepairedHeaderLease : RepairedHeaderAF;
		} else if (newSections.includes(currentTab)) {
			TableHeader = isLeasing ? PurchasedHeaderLease : PurchasedHeaderAF;
		} else {
			TableHeader = isLeasing ? AwaitingHeaderLease : AwaitingHeaderAF;
		}

		setTableHeadCells(TableHeader);
	};

	const handleDateFilterChange = (e) => {
		// Filter TableData based on date - All Time, Today, Last 7 days, Last 30 days, Last 6 months, Last 12 months
		let filteredTableData = getFilteredTableData(e.target.value, tableData);
		setDateFilter(e.target.value);
		setFilteredData(filteredTableData);
	};

	const handleDeleteAction = () => {
		console.log("selected", selectedItems);
		setConfirmModal(false);
		handleDeleteLOG(selectedItems);
	};

	const leaseOnly = (currentTab) => {
		const LeaseOnlySections = [];
		if (LeaseOnlySections.includes(currentTab)) return false;
		return true;
	};

	const PageTableToolbar = ({ selected }) => {
		return (
			<TableToolbar>
				<div className='_notification'>{filteredData.length} Item(s) Found</div>

				<div className='_buttons'>
					<Select
						value={leaseOnly(currentTab) ? currentFilter : "lease"}
						className='toolbarSelect'
						onChange={(e) => handleFilterChange(e)}>
						<MenuItem value='lease'>Leasing</MenuItem>
						{leaseOnly(currentTab) && <MenuItem value='AFinance'>Apprenticeship Finance</MenuItem>}
					</Select>

					<Select value={dateFilter} className='toolbarSelect' onChange={(e) => handleDateFilterChange(e)}>
						<MenuItem value='Today'>Today</MenuItem>
						<MenuItem value='Week'>Last 7 days</MenuItem>
						<MenuItem value='Month'>Last 30 days</MenuItem>
						<MenuItem value='6 Months'>Last 6 months</MenuItem>
						<MenuItem value='Year'>Last 12 months</MenuItem>
						<MenuItem value='All'>All Time</MenuItem>
					</Select>

					{getCurrentUserInfo().role === "_Super Admin" && (
						<TableButton
							variant='outlined'
							color='error'
							onClick={() => {
								setSelectedItems(selected);
								setConfirmModal(true);
							}}>
							<img src={DeleteIcon} alt='' />
						</TableButton>
					)}

					{/* <TableButton variant='outlined' color='primary'>
						<img src={ExportIcon} alt='' />
					</TableButton> */}
				</div>
			</TableToolbar>
		);
	};

	return (
		<>
			<DataTable TableData={filteredData} headCells={TableHeadCells} TableToolbar={PageTableToolbar} />
			{confirmModal && (
				<ConfirmModal
					confirmModal={confirmModal}
					setConfirmModal={setConfirmModal}
					content={{
						title: "Delete Logistics",
						desc: "Are you sure you want to delete this Logistics item(s)?",
						btnText: "Yes, Delete",
					}}
					handleDeleteAction={handleDeleteAction}
				/>
			)}
		</>
	);
};

export default LogisticsTable;
